// extracted by mini-css-extract-plugin
module.exports =  {"tipsContainer":"tipsContainer__IKAIO","statusText":"statusText__D2bzc","statusSuccess":"statusSuccess__itFu8","statusError":"statusError__oONo7","tipsList":"tipsList__Hg9Mf"};